import src from "IMAGE";
export default { src, width: 731, height: 96, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AB1QZWckZH5/LX+hojGJrasocI2NLX+hoC6Bo6ImaoaG16sN78XNlMsAAAAASUVORK5CYII="};
